import { useState } from 'react'
import { releasesApi, type ReleasePr } from '@/api/releases'

export function ReleasePrDetails({ pr }: { pr: ReleasePr }) {
  const [open, setOpen] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [data, setData] = useState<Awaited<ReturnType<typeof releasesApi.details>> | null>(null)
  const show = async () => {
    if (open) { setOpen(false); return }
    setOpen(true); setBusy(true); setError('')
    try { setData(await releasesApi.details(pr)) }
    catch { setData(null); setError('לא ניתן לטעון את הבדיקות והשינויים. נסה לסנכרן ולפתוח שוב.') }
    finally { setBusy(false) }
  }
  return <section className="mt-3 min-w-0">
    <button aria-expanded={open} onClick={() => void show()} disabled={busy} className="rounded-lg border border-gray-600 px-3 py-2 text-sm">{open ? 'סגור בדיקות ושינויים' : 'בדיקות ושינויים מה־PR'}</button>
    {open && <div className="mt-2 min-w-0 space-y-2 rounded-lg border border-gray-700 p-3 text-sm">
      {busy && <p>טוען מ־GitHub…</p>}{error && <p role="alert" className="text-red-300">{error}</p>}
      {data && data.head_sha === pr.head_sha && <>
        <p>מצב המיזוג: {data.merge_state}</p>
        <h3 className="font-semibold">בדיקות</h3>
        {data.statuses.map(status => <p key={status.name} className="break-words"><bdi>{status.name}</bdi> · {status.state} · {status.description}</p>)}
        {!data.checks.length && <p className="text-gray-400">אין בדיקות להצגה.</p>}
        {data.checks.map((check, index) => <p key={`${check.name}-${index}`} className="break-words"><bdi>{check.name}</bdi> · {check.conclusion ?? check.status}</p>)}
        <h3 className="pt-2 font-semibold">קבצים ששונו</h3>
        {data.files.map(file => <details key={file.path} className="min-w-0 rounded border border-gray-700 p-2"><summary className="cursor-pointer break-all"><bdi>{file.path}</bdi> · +{file.additions} / −{file.deletions}</summary><pre dir="ltr" className="mt-2 max-h-80 overflow-auto whitespace-pre-wrap break-all text-left text-xs">{file.patch ?? 'ההבדל בקובץ אינו זמין בתצוגה.'}</pre></details>)}
        {data.truncated && <p className="text-amber-300">מוצגים עד 100 קבצים ובדיקות. ההבדלים בקבצים ארוכים עשויים להיות מקוצרים.</p>}
      </>}
    </div>}
  </section>
}
